import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import type { ActionsDrawerVariant } from "web_myplann/Infrastructure/Themes/Colors";
import {
	MyPlannDrawer,
	type MyPlannDrawerProps,
} from "web_myplann/Shared/Components/MyPlannDrawer";
import {
	ActionsDrawerRow,
	type DrawerAction,
} from "web_myplann/Shared/Components/Redesign/ActionsDrawerRow";

type Props = Pick<
	MyPlannDrawerProps,
	"open" | "title" | "concealed" | "grabber"
> & {
	actions: DrawerAction[];
	variant?: ActionsDrawerVariant;
	onClose: () => void;
};

export const ActionsDrawerRedesign: FC<Props> = ({
	open,
	title,
	concealed,
	grabber,
	actions,
	variant = "divided",
	onClose,
}) => {
	const { actionsDrawer } = useTheme();

	return (
		<MyPlannDrawer
			open={open}
			onClose={onClose}
			title={title}
			concealed={concealed}
			grabber={grabber}
		>
			<Stack pb={actionsDrawer[variant].paddingBottom}>
				{actions.map((action, index) => (
					<ActionsDrawerRow
						key={action.key}
						action={action}
						isLast={index === actions.length - 1}
						variant={variant}
					/>
				))}
			</Stack>
		</MyPlannDrawer>
	);
};
